module.exports = __webpack_public_path__ + "img/bg-terms-hero.c587c47.jpg";